import {
  AppStoreBadges,
  BeyondRewardsHeading,
  StyledCard,
  StyledPhoneImage,
} from '@/src/components/Banners/GetBeyondBanner/GetBeyondBanner.styles';
import { theme } from '@ovotech/element-v5';
import BeyondImageNoDDLarge from '@/src/resources/beyond/beyond-mockup-no-dd-large.png';
import BeyondImageNoDDSmall from '@/src/resources/beyond/beyond-mockup-no-dd-small.png';
import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@/src/utils/mediaQuery';
import { useAnalytics } from '@ovotech/ui-tools';
import { BEYOND_BANNER } from '@/src/constants/analytics';
import { useBeyondWebTestVariant } from '@/src/components/Banners/GetBeyondBanner/useBeyondWebTestVariant';
import { useBeyondAccountFlags } from '@/src/hooks/useBeyondAccountFlags/useBeyondAccountFlags';

const UnlockInAppText = styled.p`
  font-size: ${theme.font.size.md.mediaQuery.lg};
  line-height: ${theme.font.lineHeight.md.mediaQuery.lg};
  letter-spacing: ${theme.font.letterSpacing.md.mediaQuery.lg};
  font-weight: ${theme.font.weight.bold};
  margin-bottom: -${theme.space['400']};
  margin-top: 41px;

  @media ${breakpoints.mediumDown} {
    width: 50%;
    margin-bottom: 34px;
    margin-top: 31px;
    font-weight: ${theme.font.weight.book};
  }
`;

const BannerBottom = styled.div`
  display: flex;
  flex-direction: row;
`;

const BannerImage = styled.picture`
  flex: 0;
  align-items: flex-end;
`;

const COMMON_PROPS = {
  'Test variant': 'Rewards',
};

export const NoAppBanner = () => {
  const { dispatch } = useAnalytics();
  const testVariant = useBeyondWebTestVariant();
  const { beyondStatus } = useBeyondAccountFlags();

  const onAppStoreClick = () => {
    dispatch({
      name: BEYOND_BANNER.NO_APP.CLICKED_APP_STORE,
      type: 'click',
      properties: {
        ...(beyondStatus && { 'Beyond Status': beyondStatus }),
        ...COMMON_PROPS,
        ...(testVariant && { 'Test variant': testVariant }),
      },
    });
  };

  const onGooglePlayClick = () => {
    dispatch({
      name: BEYOND_BANNER.NO_APP.CLICKED_GOOGLE_PLAY,
      type: 'click',
      properties: {
        ...(beyondStatus && { 'Beyond Status': beyondStatus }),
        ...COMMON_PROPS,
        ...(testVariant && { 'Test variant': testVariant }),
      },
    });
  };

  return (
    <StyledCard variant="green">
      <BeyondRewardsHeading />
      <UnlockInAppText>Unlock them in the OVO app</UnlockInAppText>
      <BannerBottom>
        <AppStoreBadges
          onAppStoreClick={onAppStoreClick}
          onGooglePlayClick={onGooglePlayClick}
        />
        <BannerImage>
          <source media={breakpoints.mediumUp} srcSet={BeyondImageNoDDLarge} />
          <StyledPhoneImage src={BeyondImageNoDDSmall} aria-hidden />
        </BannerImage>
      </BannerBottom>
    </StyledCard>
  );
};
